import{a as r}from"./chunk-RCAWOLNR.js";import{a as t}from"./chunk-6WW3A7FF.js";import{m as o}from"./chunk-HBP5N4FR.js";o();var i=!1;function u(e){if(e.operations){let[a]=t(e);return r(a.value)}else i||(console.error(`Operations field missing for txHash: ${e.txHash}.
          Unable to compute value field.`),i=!0);return r(e.value)}export{u as a};
//# sourceMappingURL=chunk-SF7QY5MK.js.map
